import { render, staticRenderFns } from "./basecanvas.vue?vue&type=template&id=35210e84&scoped=true&"
import script from "./basecanvas.vue?vue&type=script&lang=js&"
export * from "./basecanvas.vue?vue&type=script&lang=js&"
import style0 from "./basecanvas.vue?vue&type=style&index=0&id=35210e84&scoped=true&lang=css&"
import style1 from "./basecanvas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35210e84",
  null
  
)

export default component.exports